<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-100 md-small-size-100 md-xsmall-size-100 text-center"
          >
            <h1 class="title">OrangeTree Bar & Restaurant
              <br>
              <small class="text-white">Welcome to be here!</small>
            </h1>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container-fluid">
          <div class="md-layout">
            <div class="md-layout-item md-size-100 md-xsmall-size-100 mx-auto text-center">
              <h2 class="title text-center">Drink & Food Menus</h2>
            </div>
            <div class="md-layout-item md-size-33 md-xsmall-size-100 mx-auto text-center">
              <img :src="menuImg" alt="orange tree menu">
            </div>
            <div class="md-layout-item md-size-33 md-xsmall-size-100 mx-auto text-center">
              <img :src="menuImg1" alt="orange tree menu">
            </div>
            <div class="md-layout-item md-size-33 md-xsmall-size-100 mx-auto text-center">
              <img :src="menuImg2" alt="orange tree menu">
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-60 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-left">Bar & Restaurant</h2>
              <h5 class="md-body-3 text-left">
                The heart & soul of this property is the Bar & Restaurant, OrangeTree, offering fine dining in a casual, cozy atmosphere. Add to this a carefully curated wine list, craft beers and cocktails. Grab a cocktail at our bar, and enjoy a bite to eat from OrangeTree. It’s a truly memorable dining experience you won’t want to miss. 
              </h5>
            </div>
            <div
              class="md-layout-item md-size-40 md-xsmall-size-100 mx-auto"
            >
              <img :src="bar1" class="t_img1" alt="Bar">
            </div>
          </div>
        </div> 
      </div>
      <hr>
      <div class="section section-middle">
        <div class="container">
          <div class="elevation-demo">
            <md-content class="md-elevation">
              <img
                :src="bar2"
                alt="Bar"
                class="img-raised"
              />
            </md-content>
            <md-content class="md-elevation">
              <div class="md-layout-item md-size-80 text-left">
                <h3 class="title text-center">Hours</h3>
                <h4>OPEN</h4>
                <h5 class="text-left">
                  4:00 p.m. – 10:00 p.m. Monday - Saturday
                  <br>(Bar service until 11:00 p.m. Fri & Sat)
                </h5>
                <h4><br>CLOSED</h4>
                <h5 class="text-left">
                  Sunday
                </h5>
              </div>
            </md-content>
          </div>
        </div>
      </div>
      <hr>
      <div class="section section-bottom">
        <div class="container">
          <div class="md-layout-item md-size-100 text-center">
              <h3 class="title">Our Food</h3>
              <h5> </h5>
            </div>
          <div class="elevation-demo">
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[3] = true">
                <img
                  :src="img3"
                  alt="Chicken Wings"
                  class="img-raised"
                />
                <i>Chicken Wings</i>
              </a>
              <modal v-if="classicModal[3]" @close="classicModalHide(3)">
                <template slot="header">
                  <h4 class="modal-title">Chicken Wings</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(3)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img3"
                  alt="Chicken Wings"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(3)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[4] = true">
                <img
                  :src="img4"
                  alt="Fries Cheese Sticks"
                  class="img-raised"
                />
                <i>Fries Cheese Sticks</i>
              </a>
              <modal v-if="classicModal[4]" @close="classicModalHide(4)">
                <template slot="header">
                  <h4 class="modal-title">Fries Cheese Sticks</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(4)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img4"
                  alt="Fries Cheese Sticks"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(4)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[5] = true">
                <img
                  :src="img5"
                  alt="Chicken Salad Sandwich on Croissant"
                  class="img-raised"
                />
                <i>Chicken Salad Sandwich on Croissant</i>
              </a>
              <modal v-if="classicModal[5]" @close="classicModalHide(5)">
                <template slot="header">
                  <h4 class="modal-title">Chicken Salad Sandwich on Croissant</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(5)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img5"
                  alt="Chicken Salad Sandwich on Croissant"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(5)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[6] = true">
                <img
                  :src="img6"
                  alt="Chicken Wings Boneless"
                  class="img-raised"
                />
                <i>Chicken Wings Boneless</i>
              </a>
              <modal v-if="classicModal[6]" @close="classicModalHide(6)">
                <template slot="header">
                  <h4 class="modal-title">Chicken Wings Boneless</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(6)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img6"
                  alt="Chicken Wings Boneless"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(6)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[7] = true">
                <img
                  :src="img7"
                  alt="Chicken Strip"
                  class="img-raised"
                />
                <i>Chicken Strip</i>
              </a>
              <modal v-if="classicModal[7]" @close="classicModalHide(7)">
                <template slot="header">
                  <h4 class="modal-title">Chicken Strip</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(7)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img7"
                  alt="Chicken Strip"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(7)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "@/components";
export default {
  components: {
    Modal
  },
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/kitchen_header.jpg")
    },
    menuImg: {
      type: String,
      default: require("@/assets/img/foodMenu.jpg")
    },
    menuImg1: {
      type: String,
      default: require("@/assets/img/startersMenu.jpg")
    },
    menuImg2: {
      type: String,
      default: require("@/assets/img/beerMenu.jpg")
    },
    bar1: {
      type: String,
      default: require("@/assets/img/kitchen_bar1.jpg")
    },
    bar2: {
      type: String,
      default: require("@/assets/img/kitchen_bar2.jpg")
    },
    img1: {
      type: String,
      default: require("@/assets/img/m1.jpg")
    },
    img2: {
      type: String,
      default: require("@/assets/img/m2.jpg")
    },
    img3: {
      type: String,
      default: require("@/assets/img/m3.jpg")
    },
    img4: {
      type: String,
      default: require("@/assets/img/m4.jpg")
    },
    img5: {
      type: String,
      default: require("@/assets/img/m5.jpg")
    },
    img6: {
      type: String,
      default: require("@/assets/img/m6.jpg")
    },
    img7: {
      type: String,
      default: require("@/assets/img/m7.jpg")
    },
    img8: {
      type: String,
      default: require("@/assets/img/m3.jpg")
    },
    img9: {
      type: String,
      default: require("@/assets/img/m4.jpg")
    },
    img10: {
      type: String,
      default: require("@/assets/img/m5.jpg")
    },
    img11: {
      type: String,
      default: require("@/assets/img/m6.jpg")
    },
    img12: {
      type: String,
      default: require("@/assets/img/m7.jpg")
    }
  },
  data() {
    return {
      classicModal: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
        11: false,
        12: false
      },
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {
    classicModalHide(e) {
      this.classicModal[e] = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  margin-bottom: 40px;
}
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.page-header {
  b {
    font-size: 4.2rem
  }
}
.info{
  padding-top: 20px;
}
.elevation-demo {
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
}
.t_img1 {
  margin-top: 58px;
}
hr {
  margin-top: 1rem;
  // margin-bottom: 0.5rem;
  border: 0;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.md-elevation {
  height: auto;
  // margin: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    width: 100%;
    height: 100%;
    position: relative;
    i {
      display: -webkit-box;
      -webkit-box-orient: horizontal;
      -webkit-box-pack: center;
      -webkit-box-align: center;
      
      display: -moz-box;
      -moz-box-orient: horizontal;
      -moz-box-pack: center;
      -moz-box-align: center;
      
      display: -o-box;
      -o-box-orient: horizontal;
      -o-box-pack: center;
      -o-box-align: center;
      
      display: -ms-box;
      -ms-box-orient: horizontal;
      -ms-box-pack: center;
      -ms-box-align: center;
      
      display: box;
      box-orient: horizontal;
      box-pack: center;
      box-align: center;
      position: absolute;
      top:0;
      right: 0;
      bottom: 0;
      left: 0;
      font-size: 1.8rem;
      line-height: 1.2;
      font-weight: bold;
      text-align: center;
      font-style: normal; 
      background: rgba(245, 124, 0, 0.5);
      color: #fff;
      opacity: 0;
      z-index: 9;
      transition: opacity 0.4s ease 0s;
    }
    &:hover {
      i {
        opacity: 1;
      }
    }
  }
}
.section-middle .md-elevation {
  width: 50%;
}
.section-bottom .md-elevation {
  width: 20%;
}
@media (max-width: 768px){
  .section-middle .md-elevation, .section-bottom .md-elevation {
    width: 100%;
  }
}
</style>
